<template>
  <div class="jwl-home__row lms-social-row">
    <h2 class="jwl-home__headline-column lms-social-row__headline" v-t="'home.socialHeadline'" />

    <div class="jwl-home__text-column lms-social-row__buttons">
      <div class="lms-social-row__buttons-top">
        <JwlButton
          class="lms-social-row__logo-button"
          button-bordered
          link-url="https://www.jwl.org/">
          <JwlSvg icon-name="jwl_sun" class="lms-social-row__logo-sun" />
          {{t('home.visitOurWebsite')}}
        </JwlButton>
        <JwlButton
          button-bordered
          link-url="https://www.jwl.org/top/newsletter"
          icon-name="envelope"
          icon-style="light">
          {{t('home.subscribeToNewsletter')}}
        </JwlButton>
      </div>
      <div class="lms-social-row__buttons-top">
        <span v-t="'home.followUs'">
        </span>
        <a class="lms-social-row__social-button"
           target="_blank"
           rel="noopener"
           href="https://www.facebook.com/JesuitWorldwideLearning">
          <JwlIcon icon-style="brand" icon-name="facebook" />
        </a>
        <a class="lms-social-row__social-button"
           target="_blank"
           rel="noopener"
           href="https://www.instagram.com/jesuitworldwidelearning">
          <JwlIcon icon-style="brand" icon-name="instagram" />
        </a>
        <a class="lms-social-row__social-button"
           target="_blank"
           rel="noopener"
           href="https://www.linkedin.com/school/jesuit-worldwide-learning/">
          <JwlIcon icon-style="brand" icon-name="linkedin" />
        </a>
        <a class="lms-social-row__social-button"
           target="_blank"
           rel="noopener"
           href="https://www.youtube.com/channel/UCnxYxjg6ILAPP-4gEPTEwEA">
          <JwlIcon icon-style="brand" icon-name="youtube" />
        </a>
        <a class="lms-social-row__social-button"
           target="_blank"
           rel="noopener"
           href="https://twitter.com/jwlupdates">
          <JwlIcon icon-style="brand" icon-name="twitter" />
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
  const { t } = useI18n();
</script>

<style lang="scss">
.lms-social-row {
  margin-bottom: 1.5rem !important;

  &__headline {
    padding-top: .3rem;
  }

  &__buttons {
    display: grid;
    grid-gap: .5rem;
    grid-template: "topRow" auto "bottomRow" auto / 100%;
  }

  &__buttons-top {
    align-items: center;
    display: flex;
    flex-flow: row wrap;
    grid-gap: .5rem;
  }

  &__logo-button {
    padding-left: 2rem;
    position: relative;
  }

  &__logo-sun {
    background-color: var(--color-white);
    border-radius: 50%;
    left: calc(-3px + .5rem);
    position: absolute;
    transform: scale(2);
    margin-right: .25rem;
    z-index: 1;
  }

  &__social-button {
    align-items: center;
    color: var(--color-gray-500);
    display: flex;
    font-size: 2rem;
    justify-content: center;
    transition: color .25s;

    &:hover,
    &:focus {
      color: var(--color-black);
    }
  }
}
</style>
